export type ParsedSofiaLink =
  | { kind: "medicalRecord"; patientNodeId: string; appointmentNodeId: string | null }
  | { kind: "chat"; chatThreadId: string }
  | { kind: "unrecognized" }

const UNRECOGNIZED_LINK: ParsedSofiaLink = { kind: "unrecognized" }

const findSearchParamCaseInsensitive = (searchParams: URLSearchParams, searchKey: string): string | null => {
  const lowerCaseSearchKey = searchKey.toLowerCase()

  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === lowerCaseSearchKey && value.length > 0) {
      return value
    }
  }

  return null
}

const toUrl = (link: string): URL | null => {
  try {
    return new URL(link, window.location.origin)
  } catch {
    return null
  }
}

const decodePathSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment)
  } catch {
    return segment
  }
}

export const parseSofiaLink = (link: string): ParsedSofiaLink => {
  const url = toUrl(link.trim())
  if (!url) {
    return UNRECOGNIZED_LINK
  }

  const pathSegments = url.pathname.split("/").filter(Boolean).map(decodePathSegment)
  const [firstSegment, secondSegment, thirdSegment] = pathSegments
  const routeName = firstSegment?.toLowerCase()

  if (routeName === "patients" && thirdSegment) {
    return {
      kind: "medicalRecord",
      patientNodeId: thirdSegment,
      appointmentNodeId: findSearchParamCaseInsensitive(url.searchParams, "appointmentId"),
    }
  }

  if (routeName === "chats" && secondSegment) {
    return { kind: "chat", chatThreadId: secondSegment }
  }

  return UNRECOGNIZED_LINK
}
